module.exports = __webpack_public_path__ + "static/pa-ris-weiq-badge-take-away-fc3bab53770977463f5f0674657d7416.png";